import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { HttpClient } from '@angular/common/http';
import { concat } from 'rxjs';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
@Component({
  selector: 'app-book-timing-modal',
  templateUrl: './book-timing-modal.component.html',
  styleUrls: ['./book-timing-modal.component.scss'],
})
export class BookTimingModalComponent {
  bookingForm: FormGroup;
  @Input() productData: any;
  minDate: string;
  estimatedDistance: string;
  sourcePostalCode: string = 'Loading...';
  destinationPostalCode: string = '';
  possibleTransportTypes = [
    'walker < 2km',
    'food',
    'parcel',
    'private hire',
    'mover',
  ];
  possibleFrequency = ['once', 'frequently'];
  possibleItemSize = ['small', 'medium', 'large'];
  estimatedPrice = '-';
  enableLoader = false;
  minTime: string;
  checkForValidTime() {
    const formDayRaw = this.bookingForm.controls['day'].value;

    // Check if the date is selected
    if (!formDayRaw) {
      this.minTime = ''; // Remove minTime if no date is set
      return;
    }

    const today = new Date();
    const selectedDate = new Date(formDayRaw);

    // Compare only the date parts
    if (selectedDate.toDateString() === today.toDateString()) {
      // Set minTime to the current time in 24-hour format
      const now = new Date();
      this.minTime = this.convertTo24Hour(
        now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      );
    } else {
      // Set minTime to a default valid time for future dates
      this.minTime = '00:00';
    }
  }

  // Convert time to 24-hour format (HH:MM)
  convertTo24Hour(time12h: string): string {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');
    if (hours === '12') {
      hours = '00';
    }

    if (modifier === 'PM') {
      hours = (parseInt(hours, 10) + 12).toString();
    }

    return `${hours.padStart(2, '0')}:${minutes}`;
  }

  parseTimeToToday(timeString) {
    const [hours, minutes] = timeString.split(':'); // Split the time string into hours and minutes
    const today = new Date(); // Get today's date
    today.setHours(hours, minutes, 0, 0); // Set the hours, minutes, seconds, and milliseconds
    return today;
  }

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private http: HttpClient,
    private authService: AuthServiceService,
    private modalService: NgbModal,
    private customerService: CustomerService
  ) {
    this.bookingForm = this.fb.group({
      day: ['', Validators.required],
      time: ['', Validators.required],
      transportType: [this.possibleTransportTypes[0], Validators.required],
      frequency: [this.possibleFrequency[0], Validators.required],
      priceBid: ['', [Validators.required, Validators.min(0)]],
      itemSize: [this.possibleItemSize[0], [Validators.required]],
      agree: [false, [Validators.required]],
      remark: [''],
    });
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
    //setTimeout(this.getEstimatedDistance, 600)
  }
  ngOnInit(): void {
    this.getPostalCodeData();
  }

  async getEstimatedDistance() {
    this.enableLoader = true;
    const userPostalCode = this.destinationPostalCode;
    this.estimatedDistance = 'Loading';
    this.authService
      .getDistanceBetweenPostalCodes(
        this.sourcePostalCode,
        this.destinationPostalCode
      )
      .subscribe(
        (data: any) => {
          this.estimatedDistance = data.distance;
          if (data.estimatedPrice) {
            this.estimatedPrice = data.estimatedPrice;
            this.bookingForm.controls['priceBid'].setValue(this.estimatedPrice);
          }
          this.enableLoader = false;
        },
        (err) => {
          console.error('distance', err);
          this.estimatedDistance = 'error';
          this.enableLoader = false;
        }
      );
  }
  async telegramPost(itemId) {
    const login = this.local.getUser();

    if (!login) return this.toastr.error('Please Login First!');

    const user = this.productData?.appUser ?? this.productData?.seller;
    if (login.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    const orderDay = this.bookingForm.controls['day'].value;
    const orderTime = this.bookingForm.controls['time'].value;
    const transportType = this.bookingForm.controls['transportType'].value;
    const frequency = this.bookingForm.controls['frequency'].value;
    const priceBid = this.bookingForm.controls['priceBid'].value;
    const itemSize = this.bookingForm.controls['itemSize'].value;
    const remark = this.bookingForm.controls['remark'].value ?? '';
    if (
      Number.isNaN(Number(this.destinationPostalCode)) ||
      Number.isNaN(Number(this.sourcePostalCode)) ||
      this.estimatedDistance == 'error'
    ) {
      this.toastr.error('Error invalid postal codes inputed!');
      return;
    }
    this.authService
      .postToTelegramChannels({
        itemId,
        orderDay,
        orderTime,
        transportType,
        frequency,
        priceBid,
        itemSize,
        remark,
        destinationPostalCode: this.destinationPostalCode,
      })
      // this.http.post(URL, , {
      //   headers: {
      //     'Authorization': `Bearer ${token}`
      //   }
      // })
      .subscribe(
        (_) => {
          this.toastr.show('Posted!');
        },
        (err) => {
          this.toastr.error('Error: ' + err.error.error);
        }
      );
  }
  async getPostalCodeData() {
    this.authService
      .getShopProductDetails({ productId: this.productData?.id })
      .subscribe({
        next: (data) => {

          this.sourcePostalCode = data.body.appUser.postalCode;
          if (
            !this.sourcePostalCode ||
            Number.isNaN(Number(this.sourcePostalCode))
          ) {
            this.modalService.dismissAll();
            this.toastr.show(
              'Cannot order this product on telegram now. Please try agian latter'
            );
          }

          this.destinationPostalCode = this.getUser()['postalCode'];
          this.getEstimatedDistance();
        },

        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong please try again latter');
          this.activeModal.close();
        },
      });
  }

  close(): void {
    this.activeModal.dismiss();
  }
  getFormErrors(): any {
    const errors: any = [];
    for (const control in this.bookingForm.controls) {
      if (this.bookingForm.controls[control].invalid) {
        errors.push(control);
      }
    }
    return errors;
  }

  submit(): void {
    if (!this.bookingForm.controls['agree'].value) {
      this.toastr.error(
        'You must agree to be contacted using whatsapp to continue'
      );
      return;
    }
    if (!this.sourcePostalCode) {
      this.toastr.error('Source Postal code is missing!');
      return;
    }
    if (!this.destinationPostalCode) {
      this.toastr.error('Destination Postal code is missing!');
      return;
    }
    if (this.estimatedDistance == 'error') {
      this.toastr.error('Error in given postal code');
      return;
    }
    if (this.minTime) {
      if (
        this.parseTimeToToday(this.minTime) >
        this.parseTimeToToday(this.bookingForm.controls['time'].value)
      ) {
        this.toastr.error('Cannot order to the past!');
        return;
      }
    }
    if (this.bookingForm.valid) {
      this.telegramPost(this.productData.id).then(() => {
        this.activeModal.close(this.bookingForm.value);
      });
    } else {
      this.toastr.error(
        'Please fill in valid information in: ' +
          this.getFormErrors().join(', ')
      );
    }
  }
}
